import { LOCALE_CODES, localeCurrencyMap } from "./locales";

export interface CurrencyRuleContext {
  isInternational: boolean;
}

export interface CurrencyRule {
  locale: string;
  apply: (currencies: string[], ctx: CurrencyRuleContext) => string[];
}

// Add one entry per culture-specific currency exception here instead of branching inside the currency dropdown components that consume this.
export const currencyRules: CurrencyRule[] = [
  {
    locale: LOCALE_CODES.Argentina,
    apply: (currencies, { isInternational }) =>
      isInternational && !currencies.includes("USD") ? [...currencies, "USD"] : currencies,
  },
];

export function getAvailableCurrencies(locale: string, ctx: CurrencyRuleContext): string[] {
  const currencies = localeCurrencyMap[locale] ?? localeCurrencyMap.en ?? [];
  const rule = currencyRules.find((r) => r.locale === locale);
  return rule ? rule.apply(currencies, ctx) : currencies;
}
